module.exports = __webpack_public_path__ + "img/qr_code_badge_white_hr.32179981.svg";